<template>
  <v-container
    class="my-0 py-0 px-0"
  >
    <v-layout
      row
      wrap
    >
      <v-flex
        xs12
        sm6
        class="my-0 py-0"
      >
        <v-select
          :items="availableTypes"
          v-model="currentTarget"
          :label="$t('Select type of target')"
          class="my-0"
          item-text="name"
          item-value="key"
          outline
        />
      </v-flex>
      <v-flex
        xs12
        sm6
        class="my-0 py-0"
      >
        <v-switch
          v-model="included"
          :label="switchIncluded"
          outline
        />
      </v-flex>
    </v-layout>
    <v-layout
      row
      wrap
    >
      <v-flex
        v-if="target === 'type'"
        xs12
        sm6
        class="my-0 py-0"
      >
        <v-autocomplete
          v-model="values"
          :items="productTypes"
          :label="$t('Product type')"
          multiple
          outline
        />
      </v-flex>
      <v-flex
        v-else-if="target === 'sku' && !loadingProducts"
        xs12
        sm6
        class="my-0 py-0"
      >
        <v-autocomplete
          v-model="values"
          :items="products"
          :label="$t('Product\'s SKU\'s')"
          item-text="sku"
          item-value="sku"
          multiple
          outline
        />
      </v-flex>
      <v-flex
        v-else-if="target === 'name' && !loadingProducts"
        xs12
        sm6
        class="my-0 py-0"
      >
        <v-autocomplete
          v-model="values"
          :items="products"
          :label="$t('Product\'s names')"
          item-text="name"
          item-value="name"
          multiple
          outline
        />
      </v-flex>
      <v-flex
        v-else-if="target === 'brand'"
        xs12
        sm6
        class="my-0 py-0"
      >
        <v-autocomplete
          v-model="values"
          :items="brands"
          :label="$t('Product\'s brands')"
          multiple
          outline
        />
      </v-flex>
      <v-flex
        v-else-if="target === 'taxonomy'"
        xs12
        sm6
        class="my-0 py-0"
      >
        <template v-if="taxonomy.length && !loadingTaxonomy">
          <v-text-field
            v-model="taxonomyFilter"
            :label="`${'Search Taxonomy'}`"
            flat
            hide-details
            class="mb-4"
          />
          <v-treeview
            v-model="values"
            :items="taxonomy"
            :search="taxonomyFilter"
            item-key="code"
            item-text="name"
            hoverable
            selectable
          />
        </template>
        <v-progress-linear
          v-else
          :indeterminate="true"
        />
      </v-flex>
      <v-flex
        v-else
        xs12
        sm6
        class="my-0 py-0"
      >
        <v-text-field
          v-model="values"
          :label="$t('Values')"
          outline
        />
      </v-flex>
      <v-flex
        xs12
        sm6
        class="my-0 py-0"
      >
        <v-btn
          @click="$emit('removeTarget', target)"
        >
          {{ $t('Remove target') }}
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'DiscountTargetConditionSingle',

  props: {
    target: {
      type: String,
      required: true
    },
    condition: {
      type: Object,
      required: true
    },
    types: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      taxonomyFilter: null,
      productTypes: ['physical', 'digital', 'virtual'],
      taxonomy: [],
      products: [],
      brands: [],
      loadingProducts: false,
      loadingTaxonomy: false
    }
  },

  computed: {
    currentTarget: {
      set (value) {
        this.$emit('replaceTarget', this.target, value)
      },
      get () {
        return this.availableTypes.find(t => t.key === this.target)
      }
    },

    included: {
      get () {
        return Object.keys(this.condition)[0] === 'in'
      },
      set (value) {
        this.$emit('setValues', this.target, value, this.values)
      }
    },

    values: {
      get () {
        return Object.values(this.condition)[0]
      },
      set (values) {
        this.$emit('setValues', this.target, this.included, values.filter(v => v))
      }
    },

    availableTypes () {
      return this.types.filter((t) => !t.exists || t.key === this.target)
    },

    switchIncluded () {
      return this.included ? this.$t('Included In Discount') : this.$t('Excluded From Discount')
    }
  },

  async created () {
    await Promise.all([this.fetchTaxonomy(), this.fetchProducts()])
  },

  methods: {
    async fetchTaxonomy () {
      this.loadingTaxonomy = true
      await this.$http.taxonomy
        .include(['children'])
        .fetch(items => {
          this.taxonomy = this.taxonomy.concat(items.filter(taxon => !taxon.parent_id))
        })
      this.loadingTaxonomy = false
    },

    async fetchProducts () {
      this.loadingProducts = true
      await this.$http.product
        .include(['children'])
        .fetch(items => {
          items.map(product => {
            if (product.children.length) {
              product.children.map(children => {
                this.products.push(children)
                this.fetchBrand(children.brand)
              })
            }
            delete product['children']
            this.products.push(product)
            this.fetchBrand(product.brand)
          }
          )
        })
      this.loadingProducts = false
    },
    fetchBrand (brand) {
      if (!this.brands.includes(brand)) {
        this.brands.push(brand)
      }
    }
  }
}
</script>
